import { Accordion } from "@circleco/compass/components/Accordion";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface DetailsComponentProps {
  spaces: Array<{ id: number; name: string }>;
}

export const DetailsComponent = ({ spaces }: DetailsComponentProps) => {
  if (spaces.length === 0) {
    return null;
  }

  return (
    <Accordion.Root
      isBoxed
      defaultValue={spaces.length <= 5 ? ["spaces-in-group"] : undefined}
    >
      <Accordion.Item value="spaces-in-group">
        <Accordion.Trigger>
          {t("space_groups.delete.spaces_count", { count: spaces.length })}
        </Accordion.Trigger>
        <Accordion.Content>
          <ul className="list-disc pl-5">
            {spaces.map(space => (
              <li key={space.id}>
                <Typography variant="label-sm" component="span">
                  {space.name}
                </Typography>
              </li>
            ))}
          </ul>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
